import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "inline-items" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark fa-w-12 mr-1 text-warning" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-right mr-2" }, null, -1)
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "text-lg-right" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Go Back")
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-8" }
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Status : ", -1)
const _hoisted_18 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("strong", null, " Priority : ", -1)
const _hoisted_22 = {
  key: 0,
  class: "green-text"
}
const _hoisted_23 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_24 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createVNode("strong", null, "Priority : ", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" N/A")
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt mr-2" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("strong", null, "Date : ", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_33 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createVNode("strong", null, "Task Description : ")
], -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "col-md-4 text-md-right" }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Members :")
], -1)
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 2,
  class: "alert alert-success d-inline-block my-4"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("strong", null, "Estimation :", -1)
const _hoisted_44 = {
  key: 0,
  class: "inline-items my-3"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Attachements :")
], -1)
const _hoisted_46 = {
  key: 1,
  class: "phaseCard",
  id: "todoInvitations"
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"card-head pb-3 mb-0\"><div class=\"row align-items-center mx-n2\"><div class=\"col-3 px-2\"><div class=\"member-heading mb-0\"><h3 class=\"card-title card-title mb-lg-0\">Phase Invitations</h3></div></div></div></div>", 1)
const _hoisted_48 = { class: "table-wrap row" }
const _hoisted_49 = { class: "table-responsive" }
const _hoisted_50 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_51 = /*#__PURE__*/_createVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "Invitations"),
    /*#__PURE__*/_createVNode("td", null, "Action")
  ])
], -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode("View Details")
const _hoisted_53 = { key: 2 }
const _hoisted_54 = /*#__PURE__*/_createVNode("strong", null, "No of Tasks :", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Reason : ")
], -1)
const _hoisted_56 = { class: "text-danger" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "with-spinner-btn" }, [
  /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "show smart contract calendar")
], -1)
const _hoisted_58 = {
  key: 5,
  class: "table-responsive"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Task Completion Status : ")
], -1)
const _hoisted_60 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_61 = /*#__PURE__*/_createVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "Date"),
    /*#__PURE__*/_createVNode("td", null, "Name"),
    /*#__PURE__*/_createVNode("td", null, "Email"),
    /*#__PURE__*/_createVNode("td", null, "Details"),
    /*#__PURE__*/_createVNode("td", null, "Total Wages (Accumulated hourly Earning)"),
    /*#__PURE__*/_createVNode("td", null, "Status"),
    /*#__PURE__*/_createVNode("td", null, "Invoice")
  ])
], -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { key: 3 }
const _hoisted_66 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_67 = {
  key: 1,
  class: "badge rounded-pill bg-danger text-white ml-1"
}
const _hoisted_68 = { key: 4 }
const _hoisted_69 = { key: 5 }
const _hoisted_70 = { class: "mt-4" }
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Generate Invoice ")
const _hoisted_74 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_75 = { key: 4 }
const _hoisted_76 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Drafts ")
const _hoisted_78 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" View Requested Invoices ")
const _hoisted_80 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Request Invoice ")
const _hoisted_82 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_83 = { key: 0 }
const _hoisted_84 = /*#__PURE__*/_createVNode("p", null, "See Invoice Generated", -1)
const _hoisted_85 = { key: 1 }
const _hoisted_86 = /*#__PURE__*/_createVNode("p", null, "You don't have Stripe Account !!!", -1)
const _hoisted_87 = { key: 1 }
const _hoisted_88 = { class: "modal-wrap default-modal" }
const _hoisted_89 = {
  class: "modal fade",
  id: "flagTaskAsCompleted",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_90 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_91 = { class: "modal-content" }
const _hoisted_92 = { class: "modal-header" }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Task Completed"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Flas this Project as Task Completed.")
], -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_95 = { class: "modal-body" }
const _hoisted_96 = { class: "form-wrap pt-0" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Details", -1)
const _hoisted_99 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_big = _resolveComponent("big")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoMembersList = _resolveComponent("ToDoMembersList")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ToDoPhaseDetailTasks = _resolveComponent("ToDoPhaseDetailTasks")
  const _component_ToDoPhaseTaskListUpdateModal = _resolveComponent("ToDoPhaseTaskListUpdateModal")
  const _component_ToDoPhasePaymentRequest = _resolveComponent("ToDoPhasePaymentRequest")
  const _component_ToDoPhasePaymentApproval = _resolveComponent("ToDoPhasePaymentApproval")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ToDoPhaseChatChannelModel = _resolveComponent("ToDoPhaseChatChannelModel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ToDoListBreadCrumb, {
      project: _ctx.selectedPhase.project,
      breadCrumbEndPoint: _ctx.state.data.endPoint
    }, null, 8, ["project", "breadCrumbEndPoint"]),
    (_ctx.state.ui.isLoading.getPhaseDetails && _ctx.selectedPhase.phase)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("ul", null, [
              (_ctx.selectedPhase.phase && _ctx.selectedPhase.phase.name)
                ? (_openBlock(), _createBlock("li", _hoisted_7, [
                    _createVNode("strong", null, [
                      _hoisted_8,
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedPhase.phase.name), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.breadcrumbs, (phase, phaseIndex) => {
                return (_openBlock(), _createBlock("li", { key: phaseIndex }, [
                  _hoisted_9,
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.redirectToPhase(phase))
                  }, _toDisplayString(phase.phase_name), 9, ["onClick"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToToDoList && _ctx.redirectToToDoList(...args)))
            }, [
              _hoisted_12,
              _hoisted_13
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getPhaseDetails,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("p", null, [
            _hoisted_17,
            (_ctx.selectedPhase.phase.status_detail)
              ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.selectedPhase.phase.status_detail.detail), 1))
              : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.selectedPhase.phase.status), 1))
          ]),
          (_ctx.selectedPhase.phase.priority_id)
            ? (_openBlock(), _createBlock("p", _hoisted_20, [
                _hoisted_21,
                (_ctx.selectedPhase.phase.priority_id === 3)
                  ? (_openBlock(), _createBlock("span", _hoisted_22, "High"))
                  : (_ctx.selectedPhase.phase.priority_id === 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_23, "Medium"))
                    : (_openBlock(), _createBlock("span", _hoisted_24, "Low"))
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_25, [
                _hoisted_26,
                _hoisted_27
              ])),
          _createVNode("div", _hoisted_28, [
            _createVNode("p", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _createVNode("span", null, _toDisplayString(_ctx.selectedPhase.phase.localStartedDate? _ctx.selectedPhase.phase.localStartedDate:'N/A'), 1),
              _hoisted_32,
              (_ctx.selectedPhase.phase.localEndDate)
                ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.selectedPhase.phase.localEndDate), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _hoisted_36,
              (_ctx.selectedPhase.phase && _ctx.selectedPhase.phase.description)
                ? (_openBlock(), _createBlock("p", _hoisted_37, [
                    _createVNode("small", null, _toDisplayString(_ctx.selectedPhase.phase.description), 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_38, "N/A"))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_39, [
          _hoisted_40,
          (_ctx.selectedPhase.phase.allMembers)
            ? (_openBlock(), _createBlock(_component_ToDoMembersList, {
                key: 0,
                projectMembers: _ctx.selectedPhase.phase.allMembers
              }, null, 8, ["projectMembers"]))
            : (_openBlock(), _createBlock("p", _hoisted_41, "N/A")),
          (_ctx.selectedPhase.phase.budget  && _ctx.selectedPhase.role != 2 && _ctx.selectedPhase.phase.budget !='$NaN')
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _hoisted_43,
                _createTextVNode(" " + _toDisplayString(_ctx.selectedPhase.phase.budget), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.selectedPhase.attachments && _ctx.selectedPhase.attachments.length)
        ? (_openBlock(), _createBlock("div", _hoisted_44, [
            _hoisted_45,
            _createVNode("ul", null, [
              _createVNode(_component_ToDoDetailsAttachment, {
                todoAttachments: _ctx.selectedPhase.attachments
              }, null, 8, ["todoAttachments"])
            ])
          ]))
        : _createCommentVNode("", true),
      (
            _ctx.selectedPhase.phase_invitations &&
            _ctx.selectedPhase.phase_invitations.length
          )
        ? (_openBlock(), _createBlock("div", _hoisted_46, [
            _hoisted_47,
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("table", _hoisted_50, [
                  _hoisted_51,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.phase_invitations, (phase, phaseIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: phaseIndex }, [
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: {
                  name: 'user-phase-task-invitation-acknowledgement',
                  params: { invitationId: phase.uuid },
                }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(phase.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            class: "default-btn d-block",
                            to: {
                  name: 'user-phase-task-invitation-acknowledgement',
                  params: { invitationId: phase.uuid },
                }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_52
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (
        _ctx.selectedPhase.phase.child_phases &&
        _ctx.selectedPhase.phase.child_phases.length
      )
        ? (_openBlock(), _createBlock("p", _hoisted_53, [
            _hoisted_54
          ]))
        : _createCommentVNode("", true),
      _hoisted_55,
      _createVNode("p", _hoisted_56, _toDisplayString(_ctx.selectedPhase.reason), 1),
      _createVNode("p", null, [
        _createVNode("button", {
          class: "btn default-btn outline secondary d-inline-block mb-0 mr-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rediretToPublicCalender && _ctx.rediretToPublicCalender(...args)))
        }, [
          _hoisted_57
        ])
      ]),
      (
        _ctx.selectedPhase.phase.child_phases &&
        _ctx.selectedPhase.phase.child_phases.length
      )
        ? (_openBlock(), _createBlock(_component_ToDoPhaseDetailTasks, {
            key: 3,
            subPhases: _ctx.selectedPhase.phase.child_phases,
            project: _ctx.selectedPhase.project,
            role: _ctx.selectedPhase.role,
            phaseId: _ctx.state.data.phaseId,
            showAction: true,
            phase: _ctx.selectedPhase.phase,
            onSelectedTasks: _ctx.selectedTasks,
            onCheckedTask: _ctx.checkedTask,
            onUpdatePhase: _ctx.addNewPhase,
            onUpdateLog: _ctx.updateLog,
            onUpdatePhaseList: _ctx.updatePhaseList
          }, null, 8, ["subPhases", "project", "role", "phaseId", "phase", "onSelectedTasks", "onCheckedTask", "onUpdatePhase", "onUpdateLog", "onUpdatePhaseList"]))
        : _createCommentVNode("", true),
      (
        (_ctx.selectedPhase.phase.child_phases &&
          _ctx.selectedPhase.phase.child_phases.length &&
          _ctx.phaseStatus &&
          _ctx.selectedPhase.role === 1) ||
        (_ctx.selectedPhase.phase.child_phases &&
          _ctx.selectedPhase.phase.child_phases.length &&
          _ctx.phaseStatus &&
          _ctx.selectedPhase.role === 4)
          ||
        (_ctx.selectedPhase.phase.child_phases &&
          _ctx.selectedPhase.phase.child_phases.length &&
          _ctx.selectedPhase.phase.todayLog &&
          _ctx.selectedPhase.role === 5))
        ? (_openBlock(), _createBlock("a", {
            key: 4,
            class: "btn default-btn mr-2",
            href: "javascript:void(0)",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToPhaseLogs && _ctx.redirectToPhaseLogs(...args)))
          }, "See Logs"))
        : _createCommentVNode("", true),
      (
        _ctx.selectedPhase.completionStatus &&
        _ctx.selectedPhase.completionStatus.detail &&
        _ctx.selectedPhase.completionStatus.detail.length
      )
        ? (_openBlock(), _createBlock("div", _hoisted_58, [
            _hoisted_59,
            _createVNode("table", _hoisted_60, [
              _hoisted_61,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.completionStatus.detail, (task, taskIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: taskIndex }, [
                    _createVNode("td", null, _toDisplayString(task.created_at), 1),
                    _createVNode("td", null, _toDisplayString(task.user.full_name), 1),
                    _createVNode("td", null, _toDisplayString(task.user.email), 1),
                    (task.detail)
                      ? (_openBlock(), _createBlock("td", _hoisted_62, _toDisplayString(task.detail), 1))
                      : (_openBlock(), _createBlock("td", _hoisted_63, "-")),
                    (task.wage)
                      ? (_openBlock(), _createBlock("td", _hoisted_64, [
                          _createVNode("strong", null, " $ " + _toDisplayString(task.wage), 1)
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_65, "-")),
                    _createVNode("td", null, [
                      (task.completed === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_66, "In Progress"))
                        : (_openBlock(), _createBlock("span", _hoisted_67, "Close"))
                    ]),
                    (task.invoice_id)
                      ? (_openBlock(), _createBlock("td", _hoisted_68, [
                          _createVNode("button", {
                            onClick: ($event: any) => (_ctx.redirectToSelectedInvoice(task.invoice_id, '2')),
                            class: "invoice-btn"
                          }, " invoice ", 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_69, "-"))
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_70, [
        (
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 4 &&
            _ctx.selectedPhase.completionStatus &&
            _ctx.selectedPhase.completionStatus.status === 1) ||
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 1 &&
            _ctx.selectedPhase.completionStatus &&
            _ctx.selectedPhase.completionStatus.status === 1)
        )
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showFlagCompleteTask && _ctx.showFlagCompleteTask(...args)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseCompleted
            ? "loading..."
            : "Flag As Completed"), 1))
          : _createCommentVNode("", true),
        (_ctx.phaseStatus && _ctx.selectedPhase.role != 5)
          ? (_openBlock(), _createBlock("a", {
              key: 1,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-3",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.redirectToChat
            ? "loading..."
            : "Give Feedback"), 1),
              _hoisted_71
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedPhase.phase.channel && _ctx.selectedPhase.role === 5)
          ? (_openBlock(), _createBlock("a", {
              key: 2,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-3",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.redirectToChat
            ? "loading..."
            : "Give Feedback"), 1),
              _hoisted_72
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.checkedTasks.length)
          ? (_openBlock(), _createBlock("a", {
              key: 3,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stripeAccountCheck && _ctx.stripeAccountCheck(...args)))
            }, [
              _hoisted_73,
              _hoisted_74
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.showGenerate)
          ? (_openBlock(), _createBlock("p", _hoisted_75, "OK"))
          : _createCommentVNode("", true),
        (
          _ctx.selectedPhase.invoices &&
          _ctx.selectedPhase.invoices.received_invoice != null
        )
          ? (_openBlock(), _createBlock("a", {
              key: 5,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (
          _ctx.redirectToRequestedInvoice(
            _ctx.selectedPhase.invoices.received_invoice.uuid,
            '1'
          )
        ))
            }, [
              _createTextVNode(_toDisplayString(_ctx.selectedPhase.invoices.received_invoice.invoice_items && _ctx.selectedPhase.invoices.received_invoice.invoice_items.length ? ' Received Invoice': ' Request Invoice'), 1),
              _hoisted_76
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.selectedPhase.invoices &&
          _ctx.selectedPhase.invoices.received_invoice != null && _ctx.selectedPhase.role != 2 && _ctx.selectedPhase.draft === 1
        )
          ? (_openBlock(), _createBlock("a", {
              key: 6,
              href: "javascript:void(0)",
              class: "btn default-btn outline draft-btn invoice-request-send mr-3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (
          _ctx.redirectToRequestedDraftInvoice(
            _ctx.selectedPhase.invoices.received_invoice.uuid,
            '1'
          )
        ))
            }, [
              _hoisted_77,
              _hoisted_78
            ]))
          : _createCommentVNode("", true),
        (
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 1 &&
            _ctx.selectedPhase.phase.parent_phase === null) ||
          (_ctx.selectedPhase.role === 4 &&
            _ctx.selectedPhase.phase.parent_phase === null &&
            _ctx.selectedPhase.invoices &&
            _ctx.selectedPhase.invoices.sent_invoice != null && _ctx.selectedPhase.invoices.sent_invoice.uuid)
        )
          ? (_openBlock(), _createBlock("a", {
              key: 7,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (
          _ctx.redirectToAllInvoice(_ctx.selectedPhase.invoices.sent_invoice.uuid, '2')
        ))
            }, [
              _hoisted_79,
              _hoisted_80
            ]))
          : _createCommentVNode("", true),
        (
          (_ctx.selectedPhase.role === 3 || _ctx.selectedPhase.role === 2) &&
          _ctx.selectedPhase.invoices &&
          _ctx.selectedPhase.invoices.sent_invoice != null
        )
          ? (_openBlock(), _createBlock("a", {
              key: 8,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (
          _ctx.redirectToAllInvoice(
            _ctx.selectedPhase.invoices.sent_invoice.uuid,
            '2'
          )
        ))
            }, [
              _hoisted_81,
              _hoisted_82
            ]))
          : _createCommentVNode("", true),
        (
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 1 &&
            _ctx.selectedPhase.phase.status === 'Close') ||
          (_ctx.selectedPhase.role === 4 && _ctx.selectedPhase.phase.status === 'Close')
        )
          ? (_openBlock(), _createBlock("a", {
              key: 9,
              class: "btn default-btn outline d-inline-block mr-3",
              href: "javascript:void(0)",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.paymentRequest && _ctx.paymentRequest(...args)))
            }, "Payment Request"))
          : _createCommentVNode("", true),
        (
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 2 &&
            _ctx.selectedPhase.phase.status === 'Close') ||
          (_ctx.phaseStatus &&
            _ctx.selectedPhase.role === 1 &&
            _ctx.selectedPhase.phase.status === 'Close')
        )
          ? (_openBlock(), _createBlock("a", {
              key: 10,
              class: "btn default-btn outline orange d-inline-block",
              href: "javascript:void(0)",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.paymentRequestApproval && _ctx.paymentRequestApproval(...args)))
            }, "Release Payment"))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.state.data.showAddPhaseModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhaseTaskListUpdateModal, {
          key: 1,
          editMode: _ctx.state.data.editMode,
          projectDetail: _ctx.selectedPhase.project,
          projectAcknowledgementDetail: _ctx.selectedPhase.phase,
          phase: _ctx.selectedPhase.phase,
          todoDetail: _ctx.selectedPhase.phase.todo,
          showAddPhase: _ctx.state.data.showAddPhaseModal,
          onClose: _ctx.showAddPhaseModal,
          onAddPhase: _ctx.addNewPhase,
          onUpdatePhaseList: _ctx.updatePhaseList
        }, null, 8, ["editMode", "projectDetail", "projectAcknowledgementDetail", "phase", "todoDetail", "showAddPhase", "onClose", "onAddPhase", "onUpdatePhaseList"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPhasePaymentRequestModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentRequest, {
          key: 2,
          showAddPhase: _ctx.state.data.showPhasePaymentRequestModal,
          role: _ctx.selectedPhase.role,
          phase: _ctx.selectedPhase.phase,
          onClose: _ctx.hideToDoPhasePaymentRequest
        }, null, 8, ["showAddPhase", "role", "phase", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPaymentRequestApprovalModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentApproval, {
          key: 3,
          showAddPhase: _ctx.state.data.showPaymentRequestApprovalModal,
          phase: _ctx.selectedPhase.phase,
          role: _ctx.selectedPhase.role,
          onClose: _ctx.closePaymentApproval
        }, null, 8, ["showAddPhase", "phase", "role", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 4,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFullMessage,
          isButton: true
        }, {
          default: _withCtx(() => [
            (
        _ctx.state.data.generatedInvoiceDetails &&
        _ctx.state.data.generatedInvoiceDetails.invoice &&
        _ctx.state.data.generatedInvoiceDetails.invoice.uuid
      )
              ? (_openBlock(), _createBlock("div", _hoisted_83, [
                  _hoisted_84,
                  _createVNode("button", {
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (
          _ctx.seeInvoiceGenerated
         && 
          _ctx.seeInvoiceGenerated
        (...args)))
                  }, " Click to see. ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_85, [
                  _hoisted_86,
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, " Click to setup account. "))
                    : (_openBlock(), _createBlock("p", _hoisted_87, "Loading..."))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPhaseChannelModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhaseChatChannelModel, {
          key: 5,
          phase: _ctx.selectedPhase.phase,
          showPhaseChannel: _ctx.state.data.showPhaseChannelModal,
          onClose: _ctx.hidePhaseChannel
        }, null, 8, ["phase", "showPhaseChannel", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_88, [
      _createVNode("div", _hoisted_89, [
        _createVNode("div", _hoisted_90, [
          _createVNode("div", _hoisted_91, [
            _createVNode("div", _hoisted_92, [
              _hoisted_93,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideFlagCompleteTask && _ctx.hideFlagCompleteTask(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_94
              ])
            ]),
            _createVNode("div", _hoisted_95, [
              _createVNode("div", _hoisted_96, [
                _createVNode("div", _hoisted_97, [
                  _hoisted_98,
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "taskcompletionDetail",
                    "aria-describedby": "emailHelp",
                    placeholder: "Task Completion Details..",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.taskCompletionDetails = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.taskCompletionDetails]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_99, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.phaseCompleted && _ctx.phaseCompleted(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseCompleted
                  ? "loading..."
                  : "Flag As Completed"), 1),
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn secondary-btn",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideFlagCompleteTask && _ctx.hideFlagCompleteTask(...args)))
              }, "Close")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}